import React from 'react'
import AppPageComponent from '@components/page/appPage.component'
import PageHeaderComponent from '@components/page/pageHeader.component'
import PageBodyComponent from '@components/page/pageBody.component'

const SettingsPage: React.FC = () => {
  return (
    <AppPageComponent>
      <PageHeaderComponent>
        <p>This is settings page</p>
      </PageHeaderComponent>
      <PageBodyComponent>...</PageBodyComponent>
    </AppPageComponent>
  )
}

export default SettingsPage
